const ROUND = 'stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"';

function sparkle(x: number, y: number, outer: number): string {
  const path = (reach: number, waist: number, turn: number): string => {
    const points = Array.from({ length: 8 }, (_, index) => {
      const radius = index % 2 === 0 ? reach : waist;
      const angle = (index * Math.PI) / 4 - Math.PI / 2 + turn;
      return `${(x + Math.cos(angle) * radius).toFixed(2)} ${(y + Math.sin(angle) * radius).toFixed(2)}`;
    });
    return `<path d="M${points.join('L')}Z" fill="currentColor"/>`;
  };
  return path(outer, outer * 0.2, 0) + path(outer * 0.55, outer * 0.14, Math.PI / 4);
}

export const CELESTE_MARK =
  `<path d="M5.5 17.5 11 5.5 19 12.5Z" fill="none" ${ROUND} stroke-width="1.4"/>` +
  sparkle(5.5, 17.5, 5) +
  sparkle(11, 5.5, 5) +
  sparkle(19, 12.5, 5);

export const METEORS_ICON =
  `<ellipse cx="9" cy="5.5" rx="7.4" ry="3" fill="none" ${ROUND} stroke-width="1.8"/>` +
  `<ellipse cx="9" cy="5.5" rx="3.4" ry="1.2" fill="none" ${ROUND} stroke-width="1.4"/>` +
  `<path d="M10.5 9.5 16.2 17" fill="none" ${ROUND} stroke-width="2.4"/>` +
  '<circle cx="17.6" cy="18.8" r="3.2" fill="currentColor"/>';
